<div style="padding: 0;border: 1px solid #c3bdbd;margin: 0 10px;  background: #f9f9f9;">
    <div style="text-align:center;border: 1px solid #c3bdbd;font-weight: 600;">

        Rating of overall communication skills
        <span (click)="close()"
            style="    float: right;cursor: pointer;background: red;color: #ffffff;padding: 0 8px;text-align: center;">
            X
        </span>

    </div>
    <div style="color:red;font-size:14px;padding:0 10px;">
        <p>Communication skills are critical to success of Jobseeker for those Jobs that requires effective
            communication skills.
            Please select the correct level of communication skills based on your interaction so that the jobseeker get
            selected for
            the job alerts. If you rate higher then the Jobseeker may fail in all interviews, similarly if you rate low
            then Jobseeker
            will reject all the jobs. Hence it highly critical to rate the jobseeker appropriately
        </p>
    </div>
    <div>
        <table style="font-size:12px">
            <thead style="color:#ffffff">
                <tr style="border:1px solid #ffffff; background: #737fc5;height: 25px;
                ">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center;">Rating</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">Description</td>
                </tr>

            </thead>
            <tbody>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">Entry Level</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">Not so strong communication skills and at
                        times, makes it difficult to understand whatever
                        communicated by the Jobseeker
                    </td>
                </tr>
                <tr style="height: 25px;background:#e2e1ff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">Moderate</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">I am able to converse with the Jobseeker,
                        but the Jobseeker appear not great in effectively
                        communicating

                    </td>
                </tr>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">Good</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A pleasant communicator and it is easy to
                        interact with Jobseeker. I am able to understand
                        whatever spoken by Jobseeker and similarly Jobseeker is able to understand whatever I
                        communicate

                    </td>
                </tr>
                <tr style="height: 25px;background:#e2e1ff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">Excellent</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">Amazing communication skills, a well groomed
                        communicator and feel like speaking to the
                        Jobseeker all the time
                    </td>
                </tr>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">Expert/Poet</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">Appears to be a proven communicator at
                        international level, a speaker, a Radio Jockey, a Poet or a
                        similar personality who is known for great communication skills in speaking and writing.

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div style="text-align:center;">
        <button (click)="close()" style="color: #fff;background: red;padding: 5px 20px;">OK, Got it</button>
    </div>

</div>